import { Box, Grid, Typography } from '@mui/material'
import { StaticImageData } from 'next/image'
import { useRouter } from 'next/router'

import Anchor from '@ecm/ui/element/Anchor'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

type ItemProps = {
  href: string
  icon: StaticImageData
  heading: string
  subHeading?: string
  features?: boolean
}

const Item = ({ href, icon, heading, subHeading, features }: ItemProps) => {
  const router = useRouter()

  return (
    <Grid
      container
      alignItems="center"
      borderRadius="8px"
      wrap="nowrap"
      p={features ? '0.25em 0.5em' : '0.5em'}
      ml="-0.5em"
      onClick={() => router.asPath !== href && router.push(href)}
      sx={{
        ...(router.asPath !== href
          ? {
              '&:hover': { md: { backgroundColor: Color.smoke.lighter } },
              '&:hover > div:nth-of-type(1)': { md: { backgroundColor: Color.white.normal } },
              cursor: 'pointer',
              transition: { md: '200ms ease-in-out' },
            }
          : {}),
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-around"
        borderRadius="2em"
        width="40px"
        height="40px"
        bgcolor={
          features ? { md: Color.smoke.lighter, xs: Color.white.normal } : Color.smoke.lighter
        }
        mr="1em"
        sx={{ transition: { md: '200ms ease-in-out' } }}
      >
        <CloudflareImage src={icon} width={30} height={30} />
      </Grid>
      <Box>
        <Anchor
          href={href}
          variant="p3"
          fontWeight={700}
          m="0"
          sx={{ ...(router.asPath === href ? { pointerEvents: 'none' } : {}) }}
        >
          {heading}
        </Anchor>
        {subHeading && (
          <Typography variant="p4" m="0" color={Color.saint.lighter}>
            {subHeading}
          </Typography>
        )}
      </Box>
    </Grid>
  )
}

export default Item
